<template>
  <header class="portal-header" role="banner">
    <div class="portal-menu-box">
      <div class="portal-menu-top">
        <div class="left">
          <img :src="logo" style="max-height:60px;object-fit: cover;" />
        </div>
        <div class="right">
          <div class="applyButton b-blue" @click="showModel = 1">
            <p class="title">我要参展</p>
            <p class="tips">预约展位</p>
          </div>
          <div class="applyButton b-orange" @click="showModel = 2">
            <p class="title">我要参观</p>
            <p class="tips">报名/签到</p>
          </div>
        </div>
      </div>
      <div class="portal-menu-content">
        <div class="portal-menu-item" @click="portalNavSelect = 0">
          <router-link class="r_link" :class="portalNavSelect == 0 ? 'navActive' : ''" :to="{ name: 'exhIndex' }">
            网站首页
          </router-link>
        </div>
        <div class="portal-menu-item" v-for="(nav, index) in menuList" :key="index" @click="portalNavSelect = nav.oid">
          <router-link class="r_link" :class="portalNavSelect == nav.oid ? 'navActive' : ''" :to="
              nav.cat_type == 'folder'
                ? { name: 'newsList', query: { cat_oid: nav.oid,cat_name:nav.cat_name } }
                : {
                    name: 'portalNewsInfo',
                    query: { cat_oid: nav.oid, oid: nav.target_oid }
                  }
            " target="_blank">
            {{ nav.cat_name }}</router-link>
          <!-- @click.native="refresh" -->
        </div>
      </div>
    </div>
    <div class="portal-model" v-if="showModel != null">
      <div class="portal-model-box" v-if="showModel == 1">
        <div class="close" @click="showModel = null">
          <img src="../assets/X.png" />
        </div>
        <div class="title">展位预定</div>
        <div class="form-box">
          <div class="form-item">
            <div class="subtitle">单位名称<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入单位名称" required v-model="query1.company_name" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">拟展出展品<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入您的展品内容" required v-model="query1.product" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">展位面积需求<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入您的展位面积需求" required v-model="query1.booth_area" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">联系人姓名<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入联系人姓名" required v-model="query1.contactor" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">手机号<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入联系人手机号" required v-model="query1.mobile" />
            </div>
          </div>
        </div>
        <div class="reserve-button" @click="boothCreate()">
          立即预定
        </div>
      </div>
      <div class="portal-model-box" v-if="showModel == 2">
        <div class="close" @click="showModel = null">
          <img src="../assets/X.png" />
        </div>
        <div class="title">展会报名</div>
        <div class="form-box">
          <div class="form-item">
            <div class="subtitle">姓名<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入您的姓名" required v-model="query2.user_name" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">身份证号<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入您的身份证号" required v-model="query2.id" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">手机号<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入联系人电话" required v-model="query2.mobile" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">单位名称<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入您的单位全称" required v-model="query2.company_name" />
            </div>
          </div>

          <div class="form-item">
            <div class="subtitle">省市地区<i> *</i></div>
            <el-cascader v-model="zip_value" :props="props1" :options="provinces" @change="handleChange" placeholder="请选择单位省市" clearable></el-cascader>
          </div>

          <div class="form-item">
            <div class="subtitle">详细地址<i> *</i></div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="请输入单位的详细地址" required v-model="query2.address" />
            </div>
          </div>
        </div>
        <div class="reserve-button" @click="exiCreate()">立即报名</div>
      </div>
    </div>
  </header>
</template>

<script>
import appsettings from "../utils/appsettings";
import { fetch, getUrlParam } from "../utils/request";
export default {
  props: [],
  data () {
    return {
      appsettings: appsettings,
      userInfo: {},
      menuList: [],
      portalNavSelect: 0,
      showModel: null,
      zip_value: null,
      zip_code: null,
      provinces: [],
      props1: null,
      exi_id: "",
      query1: {
        company_name: "",
        product: "",
        booth_area: "",
        contactor: "",
        mobile: "",
        exi_id: ""
      },
      query2: {
        user_name: "",
        id: "",
        mobile: "",
        company_name: "",
        zip: "",
        address: "",
        exi_id: "",
        timer: ""
      },
      company_oid: null,
      logo: "",
      exi_main: {}
    };
  },
  components: {},
  computed: {},
  created () {
    this.portalNavSelect = getUrlParam("cat_oid");
    console.log("portalNavSelect--", this.portalNavSelect);
    // this.timer = setInterval(() => {
    this.exi_id = this.$store.state.exiOid;

    if (this.exi_id != "") {
      this.getMenusList();
      // clearInterval(this.timer);
    } else {
      this.getExiOid();
    }
    // }, 1000);

    this.getAreaList();
    let this_ = this;
    this.props1 = {
      lazy: true,
      lazyLoad (node, resolve) {
        if (node.data.level == 1) {
          this_.onProvinceChange(node.data.id).then(res => {
            resolve(res);
          });
        } else if (node.data.level == 2) {
          this_.onCityChange(node.data.id).then(res => {
            resolve(res);
          });
        }
      }
    };
  },
  mounted () { },
  methods: {
    getExiOid () {
      let _url = document.URL.split("#")[0];
      let url = _url.substring(0, _url.length - 1);

      fetch("post", "/eximain/exioid", {
        url
      }).then(res => {
        if (res.status == 0) {
          console.log("header--getExiOid---", res);

          this.$store.commit("setExiOid", res.data.oid);
          this.getMenusList();
          this.getExiMain();
        }
      });
    },
    getExiMain () {
      fetch("post", "/eximain/info", {
        exi_id: this.$store.state.exiOid
      }).then(res => {
        if (res.status == 0) {
          this.company_oid = res.data.company_oid;
          //this.getCominfo();
          this.logo = res.data.logo;
        }
      });
    },
    getCominfo () {
      fetch("post", "exicompany/info", {
        oid: this.company_oid
      }).then(res => {
        if (res.status == 0) {
          console.log('cominfo---', res);
          this.logo = res.data.logo;
        }
      })
    },
    getMenusList () {
      fetch("post", "/eximain/index/menus", {
        exi_id: this.$store.state.exiOid
      }).then(res => {
        if (res.status == 0) {
          console.log("getMenusList---", res);
          this.menuList = res.data.datas;
        }
      });
    },
    boothCreate () {
      let query1 = this.query1;
      if (query1.company_name == "") {
        this.$message.error("请输入单位名称");
        return;
      }
      if (query1.product == "") {
        this.$message.error("请输入您的展品内容");
        return;
      }
      if (query1.booth_area == "") {
        this.$message.error("请输入您的展位面积需求");
        return;
      }
      if (query1.contactor == "") {
        this.$message.error("请输入联系人姓名");
        return;
      }
      if (query1.mobile == "") {
        this.$message.error("请输入联系人手机号");
        return;
      }

      this.query1.exi_id = this.$store.state.exiOid;
      fetch("post", "/booth/reserve/create", this.query1).then(res => {
        if (res.status == 0) {
          console.log("boothCreate---", res);
          this.showModel = null;
          this.$message.success("报名成功");
          this.query1 = {
            company_name: "",
            product: "",
            booth_area: "",
            contactor: "",
            mobile: "",
            exi_id: this.$store.state.exiOid
          };
        }else{
          this.$message.error(res.message);
        }
      });
    },
    exiCreate () {
      let query2 = this.query2;
      if (query2.user_name == "") {
        this.$message.error("请输入您的姓名");
        return;
      }
      var pattern = /^\d{17}[\d|x|X]/;
      if (query2.id == "") {
        this.$message.error("请输入您的身份证号");
        return;
      }else if(!pattern.test(query2.id)){
        console.log(pattern.test(query2.id))
        this.$message.error("请输入正确身份证号");
        return;
      }
      var pattern1 = /^1[3456789]\d{9}$/;
      if (query2.mobile == "") {
        this.$message.error("请输入联系人手机号");
        return;
      }else if(!pattern1.test(query2.mobile)){
        this.$message.error("请输入正确手机号");
        return;
      }

      if (query2.company_name == "") {
        this.$message.error("请输入您的单位全称");
        return;
      }
      if (query2.zip == "") {
        this.$message.error("请选择单位省市");
        return;
      }
      if (query2.address == "") {
        this.$message.error("请输入单位的详细地址");
        return;
      }
      this.query2.exi_id = this.$store.state.exiOid;
      fetch("post", "/visitor/create", this.query2).then(res => {
        if (res.status == 0) {
          console.log("exiCreate---", res);
          this.showModel = null;
          this.$message.success("报名成功");
          this.query2 = {
            user_name: "",
            id: "",
            mobile: "",
            company_name: "",
            zip: "",
            address: "",
            exi_id: this.$store.state.exiOid
          };
        }else{
          this.$message.error(res.message);
        }
      });
    },
    refresh () {
      this.$router.go(0);
    },
    resizeWin () {
      this.htmlWidth = document.documentElement.scrollWidth;
      this.imgHeight = (this.htmlWidth / 1920) * 580 + "px";
    },

    getAreaList () {
      fetch("post", "utility/province/retrieve")
        .then(res => {
          if (res.status == 0) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                item.label = item.name;
                item.value = item.id;
                item.level = 1;
                // 钓鱼岛就一级
                if (item.id == 900000) {
                  item.leaf = 1;
                }
              });
            }
            this.provinces = res.data;
          }
        })
        .catch(err => { });
    },
    onProvinceChange (e) {
      //获取该省城市列表
      return new Promise(resolve => {
        var body = {
          provincecode: e
        };
        fetch("post", "utility/city/retrieve", body).then(res => {
          if (res.status == 0) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                item.label = item.name;
                item.value = item.id;
                item.level = 2;
              });
            }
            resolve(res.data);
          }
        });
      });
    },
    onCityChange (e) {
      return new Promise(resolve => {
        var body = {
          citycode: e
        };
        fetch("post", "utility/district/retrieve", body).then(res => {
          if (res.status == 0) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                item.label = item.name;
                item.value = item.id;
                item.level = 3;
                item.leaf = 3;
              });
            }
            resolve(res.data);
          }
        });
      });
      //获取区列表
    },
    handleChange (value) {
      if (value.length > 0) {
        this.query2.zip = value[value.length - 1];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.portal-header {
  width: 100%;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  .portal-menu-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 23px;
    .portal-menu-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-content: center;
      padding: 16px 0 27px;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .right {
        display: flex;
        width: 360px;
        justify-content: space-between;
        .applyButton {
          cursor: pointer;
          width: 160px;
          height: 60px;
          border-radius: 30px;
          text-align: center;
        }
        .b-blue {
          background: linear-gradient(0deg, #0d5eff 0%, #02a1ff 100%);
        }
        .b-orange {
          background: linear-gradient(0deg, #f58002 0%, #ffb502 100%);
        }
        .title {
          color: #fff;
          margin-top: 13px;
          margin-bottom: 4px;
          font-size: 20px;
          font-family: PingFangSC;
          font-weight: 600;
          line-height: 20px;
        }
        .tips {
          color: #fff;
          margin-bottom: 0;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 1;
        }
      }
    }
    .portal-menu-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .portal-menu-item {
        cursor: pointer;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #7a7b7d;
        line-height: 18px;
        .r_link {
          border-bottom: none;
          color: #7a7b7d;
        }
      }
      .navActive {
        color: #08f !important;
        font-weight: bold;
        opacity: 0.8;
      }
    }
  }
  .portal-banner-box {
    width: 100%;
    background: #fff;
    min-height: 1px;
  }
  .portal-model {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
    .portal-model-box {
      width: 720px;
      height: 600px;
      background: #fff;
      box-shadow: 7px 4px 37px 1px #6b7080;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 28px 30px;
      .close {
        cursor: pointer;
        width: 18px;
        height: 18px;
        opacity: 1;
        float: unset;
        position: absolute;
        right: 30px;
        top: 28px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #101010;
        line-height: 20px;
        margin: 37px 44px 46px;
      }
      .form-box {
        width: calc(100% - 88px);
        margin: 0 44px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .form-item {
          margin-bottom: 29px;
          width: 100%;
          max-width: 244px;
          .subtitle {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #101010;
            line-height: 20px;
            margin-bottom: 15px;
            i {
              font-style: unset;
              color: red;
            }
          }
          .form-group {
            width: 100%;
            .form-control {
              width: 100%;
              height: 40px;
              padding: 13px 18px;
              font-size: 14px;
              color: #101010;
              line-height: 20px;
              background: #f5f5f5;
              border-radius: 2px;
              border: unset;
            }
          }
        }
      }
      .reserve-button {
        display: inline-block;
        padding: 13px 122px;
        background: #0088ff;
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
        position: absolute;
        bottom: 67px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PortalHeader.vue